import React__default from 'react';
import { TooltipCore } from '../shared/components/Tooltip.mjs';
import { Typography } from './Typography.mjs';

const Tooltip = (props)=>{
    return /*#__PURE__*/ React__default.createElement(TooltipCore, {
        ...props,
        TypographyComponent: Typography
    });
};

export { Tooltip };
//# sourceMappingURL=Tooltip.mjs.map
